import DO_NOTHING_MUTATION from './doNothing.js';
import { client } from 'index';

const refetchQueries = queryList => {
  console.log('queryList', queryList);
  client.mutate({ mutation: DO_NOTHING_MUTATION, refetchQueries: () => queryList });
};

export default refetchQueries;
